
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store";

// Vendors
import moment from "moment";

// Models
import {AdministratorPlayersProfileMatchesListIndex} from "@/models/app/administrator/players/profile/matches/list/index"
import {AppCommonMatchCategory} from "@/models/app/common/match-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AdministratorPlayersProfileMatchesListFormCreateIndexVue from "@/views/app/administrator/players/profile/matches/list/form/create.vue";
import AdministratorPlayersProfileMatchesListFormUpdateIndexVue from "@/views/app/administrator/players/profile/matches/list/form/update.vue";
import AdministratorPlayersProfileMatchesListFormRemoveIndexVue from "@/views/app/administrator/players/profile/matches/list/form/remove.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  props: [
    "matchCategories",
  ],
  components: {
    ElRow,
    ElCol,
    AdministratorPlayersProfileMatchesListFormCreateIndexVue,
    AdministratorPlayersProfileMatchesListFormUpdateIndexVue,
    AdministratorPlayersProfileMatchesListFormRemoveIndexVue,
  },
})
export default class AdministratorPlayersProfileMatchesListIndexVue extends Vue {
  isLoading: boolean | null = false;

  formData: any = {
    filter: {
      user_id: "*",
      match_category_id: "*",
      date: [
        moment(),
        moment().add(14, "days"),
      ],
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };

  moment: any = null;

  matchCategories: Array<AppCommonMatchCategory> = [];

  matches: Array<AdministratorPlayersProfileMatchesListIndex> = [];

  async getMatches(formData: any = null): Promise<void> {
    this.isLoading = true;

    if (formData) {
      this.formData = formData;
    }

    await getRequest({
      uri: `/common/matches`,
      formData: this.formData,
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.matches = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    this.moment = moment;
    this.formData.filter.user_id = this.$route.params.id;
    await this.getMatches();
  }
}
